import { isDefined } from '../../utils/functions.js';
import '../../math/Graph.js';
import { Rect, Point } from '../../math/Shapes.js';
import '@progress/kendo-drawing';
import { deepExtend } from '../../utils/deep-extend.js';
import '../../svg/Rotation.js';
import { Circle } from '../../svg/Circle.js';

class ConnectorVisual {
    constructor(connector) {
        this.options = deepExtend({}, connector.options);
        this._c = connector;
        this.visual = new Circle(this.options);
        this.refresh();
    }
    _hover(value) {
        const options = this.options, hover = options.hover;
        let stroke = options.stroke, fill = options.fill;
        if (value && isDefined(hover.stroke)) {
            stroke = deepExtend({}, stroke, hover.stroke);
        }
        if (value && isDefined(hover.fill)) {
            fill = hover.fill;
        }
        this.visual.redraw({
            stroke: stroke,
            fill: fill
        });
    }
    refresh() {
        const p = this._c.shape.diagram.modelToView(this._c.position()), relative = p.minus(this._c.shape.bounds('transformed').topLeft()), value = new Rect(p.x, p.y, 0, 0);
        value.inflate(this.options.width / 2, this.options.height / 2);
        this._visualBounds = value;
        this.visual.redraw({ center: new Point(relative.x, relative.y) });
    }
    _hitTest(p) {
        const tp = this._c.shape.diagram.modelToView(p);
        return this._visualBounds.contains(tp);
    }
}

export { ConnectorVisual };
